import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Button } from '../components/ui/button';
import { LayoutDashboard, Package, Users, ShoppingCart, BarChart3, DollarSign, LogOut, Settings, Utensils, Truck, MonitorPlay, Factory, AlertTriangle, BookOpen, Wallet,Vault } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { logoUrl } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getNavItems = (role) => {
    if (role === 'visualizador') {
      return [
        { path: '/sales', label: 'Nova Venda', icon: ShoppingCart },
        { path: '/reports', label: 'Relatórios', icon: BarChart3 }
      ];
    }

    const items = [
      { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { path: '/products', label: 'Produtos', icon: Package },
      { path: '/stock-adjustments', label: 'Baixas de Estoque', icon: AlertTriangle },
      { path: '/suppliers', label: 'Fornecedores', icon: Factory },
      { path: '/purchases', label: 'Compras', icon: Truck },
      { path: '/customers', label: 'Clientes', icon: Users },
      { path: '/sales', label: 'Nova Venda', icon: ShoppingCart },
      { path: '/dinners', label: 'Jantas', icon: Users },
      { path: '/event-menu', label: 'Eventos', icon: MonitorPlay },
      { path: '/reports', label: 'Relatórios', icon: BarChart3 },
      { path: '/accounts-receivable', label: 'Contas a Receber', icon: DollarSign },
    ];

    if (role === 'admin') {
      items.push({ path: '/churrasqueiros', label: 'Churrasqueiros', icon: Utensils });
      items.push({ path: '/tesouraria/caixa', label: 'Livro Caixa', icon: BookOpen });
      items.push({ path: '/tesouraria/mensalidades', label: 'Mensalidades', icon: Wallet });
      items.push({ path: '/tesouraria/dashboard', label: 'fPanel', icon: Vault });
      items.push({ path: '/settings', label: 'Configurações', icon: Settings });
    }

    return items;
  };

  const navItems = getNavItems(user?.role);

  return (
    <nav className="bg-card border-b-2 border-border" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between min-h-[64px] py-2">
          
          <Link to={user?.role === 'visualizador' ? '/reports' : '/dashboard'} className="flex items-center gap-3 shrink-0 mr-4">
            {logoUrl ? (
              <img 
                src={logoUrl} 
                alt="Logo" 
                className="h-16 object-contain max-w-[200px] drop-shadow-[0_0_20px_rgba(250,204,21,0.6)]" 
                data-testid="navbar-logo"
                onError={(e) => {
                  console.error('Error loading logo:', logoUrl);
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div className="text-2xl font-black uppercase tracking-tight bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 bg-clip-text text-transparent drop-shadow-[0_0_12px_rgba(250,204,21,0.8)]">
                Bar Cabrones
              </div>
            )}
          </Link>
          
          <div className="hidden md:flex flex-wrap items-center gap-1 flex-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link key={item.path} to={item.path}>
                  <Button
                    variant="ghost"
                    className={`font-medium uppercase text-xs tracking-wider px-2 ${
                      isActive 
                        ? 'bg-primary/10 text-primary hover:bg-primary/20' 
                        : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                    }`}
                    data-testid={`nav-${item.path.replace('/', '')}`}
                  >
                    <Icon className="mr-1 h-4 w-4" />
                    {item.label}
                  </Button>
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-4 shrink-0 ml-2">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-medium text-foreground">{user?.name}</p>
              <p className="text-xs text-muted-foreground uppercase font-mono">{user?.role}</p>
            </div>
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="hover:bg-destructive/10 hover:text-destructive px-2"
              data-testid="logout-button"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;
